<template>
  <div :class="$style.box">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'gameCenter'
}
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: auto;
  background-color: #ededed;
}
</style>
